/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiDom from '@goldwasserexchange/oui-dom';
import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';
import { useMakeArticleSearchPath } from '../../../../context';

const style: ouiStyle.InStyle = {
  flexGrow: 1,
  widthLines: 'full',
};

const css = ouiStyle.makeCss(style);

export const ArticleSearchForm = (props: React.PropsWithChildren<{
  inputId: string,
}>) => {
  const {
    inputId,
    children,
  } = props;
  const makePath = useMakeArticleSearchPath();
  const history = ouiDom.A.useHistory();
  const onSubmit = React.useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const formData = new FormData(e.currentTarget);
      const search = formData.get(inputId);
      if (search != null && search !== '' && typeof search === 'string') {
        history.push(makePath(search));
      }
    },
    [inputId, makePath, history],
  );
  return (
    <form
      onSubmit={onSubmit}
      css={css}
    >
      {children}
    </form>
  );
};
